import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";
import DateAdapter from "../../../adapters/DateAdapter";

export default class GetPaymentReminderPreviewResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "message": "Hola, te recordamos que tenés facturas vencidas pendientes de pago. Te pedimos que regularices la situación a la brevedad.",
                "subject": "Recordatorio de pago — Client123BN123",
                "receivers": ["cobranzas@dundermifflin.com"],
                "blind_copy_receivers": ["kam@dundermifflin.com", "cobranzas2@dundermifflin.com"],
                "overdue_invoices": [{
                    "number": "12345-123456",
                    "expiration_date": "2026-09-16",
                    "days_overdue": 8,
                    "total": {"amount": "1500.0000", "currency": "ARS"},
                    "pending_balance": {"amount": "1000.0000", "currency": "ARS"},
                    "reminder_history": {
                        "has_reminders": true,
                        "count": 2,
                        "first_reminder_sent_at": "2026-09-20T14:30:00-03:00",
                        "last_reminder_sent_at": "2026-09-27T10:15:00-03:00",
                        "last_reminder_sender_email": "kam@dundermifflin.com"
                    }
                }, {
                    "number": "12345-123457",
                    "expiration_date": "2026-09-10",
                    "days_overdue": 14,
                    "total": {"amount": "800.0000", "currency": "ARS"},
                    "pending_balance": {"amount": "800.0000", "currency": "ARS"},
                    "reminder_history": {
                        "has_reminders": false,
                        "count": 0,
                        "first_reminder_sent_at": null,
                        "last_reminder_sent_at": null,
                        "last_reminder_sender_email": null
                    }
                }],
                "payment_track_record": {
                    "customer_since": "2025-03-12",
                    "paid_invoices": 14,
                    "late_paid_invoices": 3,
                    "upcoming_invoices": 2
                },
                "customer_debt_summary": {
                    "total_debt": {"amount": "2300.0000", "currency": "ARS"},
                    "overdue_debt": {"amount": "1800.0000", "currency": "ARS"},
                    "is_in_an_overdue_tier": true,
                    "worst_tier": {"code": "8_to_15", "label": "+7 a 15"},
                    "last_payment": {
                        "paid_on": "2026-09-05",
                        "amount": {"amount": "500.0000", "currency": "ARS"}
                    }
                }
            },
            errors: []
        }
    }

    message() {
        return this.content().message;
    }

    subject() {
        return this.content().subject;
    }

    receivers() {
        return this.content().receivers;
    }

    blindCopyReceivers() {
        return this.content().blind_copy_receivers;
    }

    overdueInvoices() {
        return this.content().overdue_invoices.map(overdueInvoice => ({
            number: overdueInvoice.number,
            expirationDate: this._adaptedDate(overdueInvoice.expiration_date),
            daysOverdue: overdueInvoice.days_overdue,
            total: overdueInvoice.total,
            pendingBalance: {amount: parseFloat(overdueInvoice.pending_balance.amount), currency: overdueInvoice.pending_balance.currency},
            reminderHistory: {
                hasReminders: overdueInvoice.reminder_history.has_reminders,
                count: overdueInvoice.reminder_history.count,
                firstReminderSentAt: this._adaptedOptionalDate(overdueInvoice.reminder_history.first_reminder_sent_at),
                lastReminderSentAt: this._adaptedOptionalDate(overdueInvoice.reminder_history.last_reminder_sent_at),
                lastReminderSenderEmail: overdueInvoice.reminder_history.last_reminder_sender_email,
            },
        }));
    }

    paymentTrackRecord() {
        const paymentTrackRecord = this.content().payment_track_record;
        return {
            customerSince: this._adaptedOptionalDate(paymentTrackRecord.customer_since),
            paidInvoices: paymentTrackRecord.paid_invoices,
            latePaidInvoices: paymentTrackRecord.late_paid_invoices,
            upcomingInvoices: paymentTrackRecord.upcoming_invoices,
        };
    }

    customerDebtSummary() {
        const customerDebtSummary = this.content().customer_debt_summary;
        return {
            totalDebt: customerDebtSummary.total_debt,
            overdueDebt: customerDebtSummary.overdue_debt,
            isInAnOverdueTier: customerDebtSummary.is_in_an_overdue_tier,
            worstTier: customerDebtSummary.worst_tier,
            lastPayment: {
                paidOn: this._adaptedOptionalDate(customerDebtSummary.last_payment.paid_on),
                amount: customerDebtSummary.last_payment.amount,
            },
        };
    }

    _adaptedDate(isoDate) {
        return new DateAdapter('DD/MM/YYYY').adapt(dayjs(isoDate));
    }

    _adaptedOptionalDate(isoDate) {
        return isoDate ? this._adaptedDate(isoDate) : null;
    }
}
